import { TableData } from "@/dto/tableData";
import { ScanToOrderCartTableInfo } from "./scanToOrderCartTableInfo";
import { DoubleCheckOrderBanner } from "@/components/banners/doubleCheckOrderBanner";
import { AlreadySentToKitchenSection } from "./alreadySentToKitchenSection";
import { CurrentItemsSection } from "./currentItemsSection";
import { RestaurantCartItem } from "@/models/cart/types";
import { ModalSpecialInstructions } from "@/components/modalSpecialInstructions/modalSpecialInstructions";
import { OrderType } from "@/constants/enum";
import { ErrorBanner } from "@/components/banners/errorBanner";
import { useTranslations } from "next-intl";
import { InactiveMenuCartOrdersBanner } from "@/app/(shop)/giftcard/components/InactiveMenuCartOrdersBanner";

export interface ScanToOrderCartContentProps {
  showSpecialInstructions: boolean;
  // eslint-disable-next-line no-unused-vars
  setShowSpecialInstructions: (value: boolean) => void;
  merchantColor: string;
  // eslint-disable-next-line no-unused-vars
  setSpecialInstructions: (value: string) => void;
  tableData: TableData;
  cartItems: RestaurantCartItem[];
  // eslint-disable-next-line no-unused-vars
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  orderType: OrderType;
  isCartEmpty: boolean;
  isRunningTabsEnabled: boolean;
  failedToSendToKitchen: boolean;
  onRequestClose: () => void;
  specialInstructions: string;
  isBusinessClosed: boolean;
  invalidItemsCriteria?: "past" | "inactive" | null;
}
export const ScanToOrderCartContent = ({
  showSpecialInstructions,
  setShowSpecialInstructions,
  merchantColor,
  setSpecialInstructions,
  tableData,
  cartItems,
  removeFromCart,
  orderType,
  isCartEmpty,
  isRunningTabsEnabled,
  failedToSendToKitchen,
  specialInstructions,
  onRequestClose,
  isBusinessClosed,
  invalidItemsCriteria = null,
}: ScanToOrderCartContentProps) => {
  const t = useTranslations("ScanToOrderCartContent");
  const itemsSentToKitchen = tableData?.order?.cart?.items;
  return (
    <div
      data-test-id="scan-to-order-cart-content"
      className="h-full overflow-auto"
    >
      <ScanToOrderCartTableInfo
        tableName={tableData.name}
        orderType={orderType}
      />
      {!isBusinessClosed && !failedToSendToKitchen && (
        <DoubleCheckOrderBanner />
      )}
      {failedToSendToKitchen && (
        <ErrorBanner text={t("failedToSendToKitchenError")} />
      )}
      {invalidItemsCriteria === "past" ||
      invalidItemsCriteria === "inactive" ? (
        <div className="p-3">
          <InactiveMenuCartOrdersBanner message={t("invalidItems")} />
        </div>
      ) : null}
      <ModalSpecialInstructions
        className="pt-8 mx-4"
        showSpecialInstructions={showSpecialInstructions}
        setShowSpecialInstructions={setShowSpecialInstructions}
        merchantColor={merchantColor}
        setSpecialInstructions={setSpecialInstructions}
        specialInstructions={specialInstructions}
      />
      <div className="flex-1 overflow-auto">
        {!isCartEmpty && (
          <CurrentItemsSection
            removeFromCart={removeFromCart}
            cartItems={cartItems}
            onRequestClose={onRequestClose}
          />
        )}
        {itemsSentToKitchen?.length > 0 && isRunningTabsEnabled && (
          <AlreadySentToKitchenSection
            items={itemsSentToKitchen}
            onRequestClose={onRequestClose}
          />
        )}
      </div>
    </div>
  );
};
